import {
    createLoginRequested,
    createLogoutRequested,
    createTokenReceivedFromUrl,
    update,
    loginRequestedOf,
    profileRequestedOf,
    loggedInOf,
    userIdOf,
    apiTokenOf,
    userProfileOf,
    eventTypes
 } from './model';
import { makeTransduce as makeTransduce_ } from './transducer';
import { profile as makeProfile } from './operations-service';
import { http } from '../services';

const init = (store, features = {}) => {

    // prefer login token from login
    const fragment = window.location.hash.substr(1);
    const matcher = /access_token=([^&]+)/
    const captures = matcher.exec(fragment)
    const apiToken = captures ? captures[1] : undefined
    if (apiToken) {
        store.dispatch(createTokenReceivedFromUrl(apiToken));
        window.location.replace("#");
        if (typeof window.history.replaceState === 'function') {
            window.history.replaceState({}, '', window.location.href.slice(0, -1));
        }
    } else if (features.AUTOLOGIN) {
    // but use the autologin value if in dev and one exists
    store.dispatch(createTokenReceivedFromUrl(features.AUTOLOGIN));
    }
};

const makeTransduce = ({oauth, apiUrl}) => {
    const config = {
        profile: (token,userId) => makeProfile(http)(apiUrl)(token)(userId),
        oauth,
        redirect: loc => { window.location.href = loc;}
    };

    return makeTransduce_(config);

};

const isLoginEvent = event => event.type && event.type === eventTypes.TOKEN_RECEIVED_FROM_URL;

export {
    createLoginRequested,
    createLogoutRequested,
    createTokenReceivedFromUrl,
    isLoginEvent,
    update,
    makeTransduce,
    userProfileOf,
    loginRequestedOf,
    loggedInOf,
    profileRequestedOf,
    userIdOf,
    apiTokenOf,
    init
};



// WEBPACK FOOTER //
// ./src/user/index.js